import React from 'react';
import SantaCatarinaPageHardcoded from './SantaCatarinaPageHardcoded';
import './SantaCatarinaPage.css';

const SantaCatarinaPage: React.FC = () => {
  // Using hardcoded version with approved beach resort content
  return <SantaCatarinaPageHardcoded />;
};

export default SantaCatarinaPage;